<template>
  <div class="flex justify-between items-center p-4 rounded-lg bg-white">
    <p>{{ pathway?.fallback_content || "Le parcours est terminé pour ce patient." }}</p>
    <BaseButton :primary="true" @click="restartPathway">
      <Icon name="mdi-refresh" class="text-white mr-2" />
      {{ pathway?.fallback_message || "Recommencer le parcours" }}
    </BaseButton>
  </div>
</template>

<script lang="ts" setup>
import {Pathway} from "@/program/interfaces/Program";
import BaseButton from "@/core/components/base/BaseButton.vue";
import Icon from "@/core/components/icon/Icon.vue";
import {pathwayApi} from "@/container";
import pathwayService from "@/pathway/services/PathwayService";

const props = defineProps<{
    pathway: Pathway;
    consumerKey: string;
}>();

defineEmits(['skipDelay']);

/**
 * Restart the pathway
 */
const restartPathway = async () => {
    await pathwayApi().createConsumerPathway(props.pathway, props.consumerKey);
    await pathwayService().updatePathway(props.pathway, props.consumerKey);
};
</script>
